import { AppFeatures } from "../../../../constants/featureFlags";
import { AppFeatureUtils } from "../../../../utils";
import { links } from "./Config.resource";

export const getCrossSell = (props = {}) => {
  const isGermanyRegulationEnabled = AppFeatureUtils.findIfIsInFeature(
    AppFeatures.GERMANY_REGULATION
  );

  const { onClickHandler, userCountry, isAuthenticated } = props;
  if (userCountry?.toUpperCase() === "DEU" && isGermanyRegulationEnabled) {
    return null;
  }

  return {
    casinoProps: {
      ariaLabel: "casino online",
      className: "casinoBrand",
      onClick: onClickHandler.onClickCasino,
      href: links.casinoUrl,
      rel: "noopener noreferrer",
      svgId: "default-logo",
      svgText: "casino",
      name: "cross sell_888casino",
      dataTestId: "uc-cross-sell-casino"
    },
    pokerProps: {
      ariaLabel: "poker online",
      className: "pokerBrand",
      onClick: onClickHandler.onClickPoker,
      href: isAuthenticated ? links.pokerUrlAuthenticated : links.pokerUrl,
      "data-navigation-ignore": true,
      rel: "noopener noreferrer",
      svgId: "default-logo",
      svgText: "poker",
      name: "cross sell_888poker",
      dataTestId: "uc-cross-sell-poker"
    }
  };
};
